module.exports = __webpack_public_path__ + "static/media/fleche-red.c9262b87.svg";